function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "_2-Dashboard_Design-Final-Copy-2",
  "data-name": "2-Dashboard_Design-Final-Copy-2",
  transform: "translate(-32 -225)"
}, /*#__PURE__*/React.createElement("g", {
  id: "avatar",
  transform: "translate(32 225)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M14.807,13.534l-2.873-.718-.245-.978a5.171,5.171,0,0,0,1.451-2.879,1.127,1.127,0,0,0,.813-.943l.187-1.5a1.123,1.123,0,0,0-.718-1.19l.069-1.412.281-.281a1.73,1.73,0,0,0,.04-2.337A3.151,3.151,0,0,0,10.972,0,4.943,4.943,0,0,0,8.13.752C4.935.818,4.5,2.3,4.5,3.75c0,.337.082,1.1.136,1.553a1.126,1.126,0,0,0-.777,1.213l.187,1.5a1.129,1.129,0,0,0,.9.965,5.2,5.2,0,0,0,1.379,2.792l-.261,1.045-2.873.718A4.206,4.206,0,0,0,0,17.625.375.375,0,0,0,.375,18h17.25A.376.376,0,0,0,18,17.624,4.209,4.209,0,0,0,14.807,13.534Z"
})));

var SvgCustomers = function SvgCustomers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Page-1",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#fff",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCustomers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/customers.d0893f04.svg";
export { ForwardRef as ReactComponent };